import { useEffect, useRef } from 'react'

export const useValueWatcher = (
  watcher: Record<string, (key: string, val: any) => void>, value: any
) => {
  const prevValue = useRef(value)

  useEffect(() => {
    if (Object.keys(watcher)?.length) {
      Object.keys(watcher).forEach((key) => {
        const func = watcher[key]
        if (prevValue.current[key] !== value[key]) {
          func(key, value[key])
        }
      })
      prevValue.current = value
    }
  }, [value])
}
